export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  LOGIN_CALLBACK: '/login/callback',
} as const

export type Route = (typeof ROUTES)[keyof typeof ROUTES]
